






















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import JobDto from '@/models/Jobs/JobDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import UpdateJobGeneralDetailsRequest from '@/models/Jobs/UpdateJobGeneralDetailsRequest';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';

@Component({
    name: 'JobGeneralDetailsEdit'
})
export default class JobGeneralDetailsEdit extends GiganautVueDialog {
 
  entity: JobDto = new JobDto();
  closingDateAsString = '';
  desiredStartDateAsString = '';
  desks: DeskDto[] = [];

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(JobDetailsModule.currentJob));
      this.desks = this.entity.branch.desks;
      if (this.entity.closingDate !== null) {
        this.closingDateAsString = new Date(this.job.closingDate).toISOString().substr(0, 10)
      } 
      if (this.entity.desiredStartDate !== null) {
        this.desiredStartDateAsString = new Date(this.job.desiredStartDate).toISOString().substr(0, 10)
      } 
      if (AgencySettingsModule.agencyUsers) {
        AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.branches) {
        await AgencySettingsModule.getBranches();
      }
    }
  }

  @Watch('entity.branch') 
  async onBranchChanged(newVal: BranchDto, oldVal: BranchDto){
    this.desks = newVal.desks;
  }

  get job() {
    return JobDetailsModule.currentJob;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get loading() {
    return JobDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new UpdateJobGeneralDetailsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.branchId = this.entity.branch.id;
    request.deskId = this.entity.desk.id
    request.ownerId = this.entity.owner.id;
    request.headcount = Number(this.entity.headcount);
    request.closingDate = this.closingDateAsString;
    request.desiredStartDate = this.desiredStartDateAsString;
    request.annualSalaryMin = this.entity.annualSalaryMin;
    request.annualSalaryMax = this.entity.annualSalaryMax;
    request.title = this.entity.title;
    
    request.isTest = this.entity.isTest;
    if (request.isTest) {
      request.testEmailAddresses = this.entity.testEmailAddresses;
    }
   
    await JobDetailsModule.editJobGeneralDetails(request)
    this.dialog = false;
  }
}
